// Which /api/time-entries URL a Reports-page run should fetch.
//
// Feedback #836 (James, 2026-09-30) — "stuck on generating report".  Billed /
// Unbilled Time by Matter show ONE matter's full history regardless of the date
// range, so they skipped from/to and asked for the firm's ENTIRE time history
// (42,669 entries, ~29 MB of JSON) only to keep one matter's rows in the
// browser.  The query took half a second and only ~1.3 MB crossed the wire;
// the ~100 s wait was the server Brotli-compressing all 29 MB at quality 11.
// The server now accepts &matter_id on the ?all=true path, so these two
// reports ask for just that matter — 16-20x less to compress.  (The same
// ship lowered the compression quality to 4 in api/src/app.js, which is what
// fixes every other large response.)
//
// Pulled out of Reports.js so the decision is testable without rendering the
// page: a regression here does not error, it just silently goes back to
// asking for the whole firm.  The source test in reportTimeEntriesUrl.test.js
// also checks Reports.js still routes through this helper.

export const MATTER_FULL_HISTORY_REPORTS = Object.freeze([
  'billed_time_by_matter',
  'unbilled_time_by_matter',
])

// A matter id from the <select> arrives as a string.  Only a whole positive
// number that fits a Postgres integer is worth sending — the server ignores
// anything else and would fall back to the unscoped firm-wide fetch, which is
// exactly the bug.
const INT4_MAX = 2147483647
function positiveIntId(v) {
  if (v === null || v === undefined) return null
  const s = String(v).trim()
  if (!/^[1-9][0-9]*$/.test(s)) return null
  if (Number(s) > INT4_MAX) return null
  return s
}

// Returns the URL to fetch, or null when there is nothing worth fetching.
//
// null only happens for a matter report without a usable matter id.  The page
// already returns before fetching when no matter is selected, so null is a
// backstop: a matter report must never quietly widen to the whole firm.
export function reportTimeEntriesUrl(reportId, { dateRange, selectedMatter } = {}) {
  if (MATTER_FULL_HISTORY_REPORTS.includes(reportId)) {
    const mid = positiveIntId(selectedMatter)
    if (!mid) return null
    return `/api/time-entries?all=true&matter_id=${encodeURIComponent(mid)}`
  }
  const start = dateRange?.start ?? ''
  const end = dateRange?.end ?? ''
  return `/api/time-entries?all=true&from=${encodeURIComponent(start)}&to=${encodeURIComponent(end)}`
}
